import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

// eslint-disable-next-line max-len
export const STUDIO_REVENUE_INSIGHTS = `${BASE_URL}/rest/v1.0/reporting/studio/{username}/insights?from={startDate}&to={endDate}`;
export const YEAR_REVENUE_URL_REPORTING = `${BASE_URL}/rest/v1.0/reporting/studio/{username}/year-comparison`;
export const EARNINGS_URL_REPORTING = `${BASE_URL}/rest/v1.0/reporting/user/{performer}/transactions`;
